<div class="dashboard-container">
  <div class="sticky-header">
    <h1 class="dashboard-title">User Feedback</h1>
    <app-date-range-selector
      [selectedPeriod]="selectedPeriod()"
      [startDate]="startDate()"
      [endDate]="endDate()"
      [includeWeek]="true"
      (periodChange)="onPeriodChange($event)"
      (dateRangeChange)="onDateRangeChange($event)"
    />
  </div>

  @if (feedbackService.errorMessage(); as error) {
    <app-error-banner [message]="error" />
  }

  <div class="dashboard-grid">
    <div class="card-wrapper full-width">
      <p-card>
        <ng-template pTemplate="title">
          <div class="feedback-toolbar">
            <span>User Feedback</span>
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input
                pInputText
                type="text"
                [ngModel]="search()"
                (ngModelChange)="search.set($event)"
                placeholder="Search content, org, user..."
                styleClass="feedback-search"
              />
            </span>
          </div>
        </ng-template>
        <p-table
          [value]="filteredFeedback()"
          [paginator]="true"
          [rows]="15"
          styleClass="p-datatable-striped"
          [tableStyle]="{ 'min-width': '60rem' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="item.createdAt">Date <p-sortIcon field="item.createdAt" /></th>
              <th pSortableColumn="item.organisation.name">
                Organisation <p-sortIcon field="item.organisation.name" />
              </th>
              <th pSortableColumn="item.user.name">User <p-sortIcon field="item.user.name" /></th>
              <th>Preview</th>
              <th>Actions</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr (click)="openDetail(row)" class="clickable-row">
              <td>{{ row.item.createdAt | date: 'medium' }}</td>
              <td>
                @if (row.item.organisation) {
                  <a
                    class="link-cell"
                    tabindex="0"
                    role="link"
                    (click)="openOrg(row.item.organisation!.id); $event.stopPropagation()"
                    (keydown.enter)="openOrg(row.item.organisation!.id); $event.stopPropagation()"
                  >
                    {{ row.item.organisation.name }}
                  </a>
                } @else {
                  <span class="text-500">N/A</span>
                }
              </td>
              <td>
                <a
                  class="link-cell"
                  tabindex="0"
                  role="link"
                  (click)="openUserSessions(row.item.user.id); $event.stopPropagation()"
                  (keydown.enter)="openUserSessions(row.item.user.id); $event.stopPropagation()"
                >
                  {{ row.item.user.name }}
                </a>
                <div class="text-xs text-500">{{ row.item.user.email }}</div>
              </td>
              <td class="text-600">{{ row.preview }}</td>
              <td>
                <p-button
                  icon="pi pi-eye"
                  [rounded]="true"
                  [text]="true"
                  styleClass="text-500"
                ></p-button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5" class="text-center p-4">No feedback found for this period.</td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="showDetailModal"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false"
  header="Feedback Details"
>
  @if (selectedFeedback(); as row) {
    <div class="flex flex-column gap-4">
      <div
        class="flex justify-content-between align-items-center border-bottom-1 surface-border pb-3"
      >
        <div class="flex gap-2 flex-column">
          <a
            class="link-cell"
            style="font-size: 1.25rem; font-weight: 700"
            tabindex="0"
            role="link"
            (click)="openUserSessions(row.item.user.id)"
            (keydown.enter)="openUserSessions(row.item.user.id)"
          >
            {{ row.item.user.name }}
          </a>
          <span class="text-sm text-500">{{ row.item.user.email }}</span>
        </div>
        <div class="text-right">
          @if (row.item.organisation) {
            <a
              class="link-cell"
              style="font-size: 1.125rem; font-weight: 600"
              tabindex="0"
              role="link"
              (click)="openOrg(row.item.organisation!.id)"
              (keydown.enter)="openOrg(row.item.organisation!.id)"
            >
              {{ row.item.organisation.name }}
            </a>
          }
          <div class="text-sm text-500">{{ row.item.createdAt | date: 'medium' }}</div>
        </div>
      </div>
      <div class="surface-ground p-4 border-round">
        @if (row.isHtml) {
          <!-- Rich-text feedback: render the markup instead of printing the tags.
               Angular sanitizes [innerHTML] by default. -->
          <div class="feedback-content line-height-3" [innerHTML]="row.item.content"></div>
        } @else {
          <p class="m-0 line-height-3" style="white-space: pre-wrap">{{ row.item.content }}</p>
        }
      </div>
    </div>
  }
</p-dialog>
